<template>
  <!-- Crop element -->
  <vue-draggable-resizable
    :class-name="redFlag ? 'crop-area-red' : 'crop-area'"
    class-name-handle="corner"
    :min-width="$options.minWidth"
    :min-height="$options.minHeight"
    :w="width"
    :h="height"
    :x="x"
    :y="y"
    :parent="true"
    :handles="['tl', 'tr', 'bl', 'br']"
    :lock-aspect-ratio="lockRatio"
    @dragging="handleDragging"
    @resizing="handleResizing"
  />
</template>

<script>
import VueDraggableResizable from "vue-draggable-resizable";

// @group Areas
// Draggable & resizable crop area rectangle with fixed aspect ratio
export default {
  name: "CropArea",
  components: {
    VueDraggableResizable
  },
  props: {
    // left padding in px
    x: {
      type: Number,
      default: 0
    },
    // top padding in px
    y: {
      type: Number,
      default: 0
    },
    // width in px
    width: {
      type: Number,
      default: 50
    },
    // height in px
    height: {
      type: Number,
      default: 50
    },
    // crop aspect ratio width to height (not used at start)
    aspectRatio: {
      type: Number,
      default: 1
    },
    redFlag: {
      type: Boolean,
      default: false
    }
  },
  minWidth: 50,
  minHeight: 50,
  data() {
    return {
      lockRatio: true
    };
  },
  watch: {
    // @vuese
    // Update crop area width and height by new aspect ratio value
    aspectRatio() {
      this.syncAspectRatio();
    }
  },
  mounted() {
    this.syncAspectRatio();
  },
  methods: {
    // @vuese
    // Synchronize area's width & height with current aspect ratio
    syncAspectRatio() {
      if (this.aspectRatio == null) {
        this.lockRatio = false;
        return;
      }

      const oldRatio = this.width / this.height;
      const newRatio = this.aspectRatio;

      const widthByHeight = this.height * newRatio;
      const heightByWidth = this.width / newRatio;

      // Release aspect ratio locking to change it
      this.lockRatio = false;

      if (newRatio > oldRatio) {
        // Stretch horizontally
        if (heightByWidth >= this.$options.minHeight) {
          this.$emit("update:height", heightByWidth);
        } else {
          this.$emit("update:width", widthByHeight);
        }
      } else {
        // Stretch vertically
        if (widthByHeight >= this.$options.minWidth) {
          this.$emit("update:width", widthByHeight);
        } else {
          this.$emit("update:height", heightByWidth);
        }
      }

      // Lock ratio again, wrapped by setTimeout, then size changes will be execute before locking
      this.$nextTick(() => (this.lockRatio = true));
    },
    // @vuese
    // Update crop left and top paddings
    // @arg x - new left padding <br>
    // @arg y - new top padding
    handleDragging(x, y) {
      this.$emit("update:x", x);
      this.$emit("update:y", y);
    },
    // @vuese
    // Update crop left and top paddings, widtj and height
    // @arg x - new left padding <br>
    // @arg y - new top padding <br>
    // @arg width - new width <br>
    // @arg height - new height
    handleResizing(x, y, width, height) {
      this.$emit("update:x", x);
      this.$emit("update:y", y);
      this.$emit("update:width", width);
      this.$emit("update:height", height);
    }
  }
};
</script>

<style scoped>
.crop-area {
  /* Absolute positioned area will be place over the image */
  position: absolute;
  top: 0;
  left: 0;

  cursor: move;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.crop-area-red {
  /* Absolute positioned area will be place over the image */
  position: absolute;
  top: 0;
  left: 0;

  cursor: move;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 0, 0, 0.959);
}
</style>

<style>
.corner {
  width: 20px;
  height: 20px;
  border: 4px solid rgba(255, 255, 255, 0.2);
}
.corner-tr {
  position: absolute;
  top: -2px;
  right: -2px;

  border-bottom-style: none;
  border-left-style: none;

  cursor: ne-resize;
}
.corner-tl {
  position: absolute;
  top: -2px;
  left: -2px;

  border-bottom-style: none;
  border-right-style: none;

  cursor: nw-resize;
}
.corner-br {
  position: absolute;
  bottom: -2px;
  right: -2px;

  border-top-style: none;
  border-left-style: none;

  cursor: se-resize;
}
.corner-bl {
  position: absolute;
  bottom: -2px;
  left: -2px;

  border-top-style: none;
  border-right-style: none;

  cursor: sw-resize;
}

.corner-tm {
  position: absolute;
  top: -2px;
  left: 50%;

  border-left-style: none;
  border-right-style: none;
  border-bottom-style: none;
}
.corner-bm {
  position: absolute;
  bottom: -2px;
  left: 50%;

  border-left-style: none;
  border-right-style: none;
  border-top-style: none;
}
.corner-mr {
  position: absolute;
  right: -2px;
  top: 50%;

  border-left-style: none;
  border-bottom-style: none;
  border-top-style: none;
}
.corner-ml {
  position: absolute;
  left: -2px;
  top: 50%;

  border-right-style: none;
  border-bottom-style: none;
  border-top-style: none;
}
</style>
